export const T = {
  en_GB: {
    edit: "Edit",
    delete: "Delete",
    cannotDeleteLastGoal: "You must have at least one goal.",
  },
  nb_NO: {
    edit: "Rediger",
    delete: "Slett",
    cannotDeleteLastGoal: "Du må ha minst ett mål.",
  },
} as const;
